export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1601687425/general/instagramLogoBlack.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1591377852/general/cflogo_black.png'
export const about = 'https://d4gs6r4c7q68d.cloudfront.net/about.jpg'
export const bg = 'https://d4gs6r4c7q68d.cloudfront.net/bg.jpg'
export const contactbg = 'https://d4gs6r4c7q68d.cloudfront.net/contactbg.webp'
export const hero = 'https://d4gs6r4c7q68d.cloudfront.net/hero.jpg'
export const heroText = 'https://d4gs6r4c7q68d.cloudfront.net/heroText3.webp'
export const logo = 'https://d4gs6r4c7q68d.cloudfront.net/logo.webp'
export const locationMap =
  'https://d4gs6r4c7q68d.cloudfront.net/locationMap.webp'
export const mobileAbout =
  'https://d4gs6r4c7q68d.cloudfront.net/mobileAbout.jpg'
export const mobileContactbg =
  'https://d4gs6r4c7q68d.cloudfront.net/mobileContactbg.webp'
export const mobileHero =
  'https://d4gs6r4c7q68d.cloudfront.net/mobileHero2.webp'
export const mobileMap = 'https://d4gs6r4c7q68d.cloudfront.net/mobileMap.webp'
export const mobileHeroText =
  'https://d4gs6r4c7q68d.cloudfront.netmobileHeroText.png'
export const mobilePromotion =
  'https://d4gs6r4c7q68d.cloudfront.net/mobilePromo.webp'
export const orderPickupButton =
  'https://d4gs6r4c7q68d.cloudfront.net/OrderPickupButton.webp'
export const promotions = 'https://d4gs6r4c7q68d.cloudfront.net/promo.webp'
export const foodGallery =
  'https://d4gs6r4c7q68d.cloudfront.net/foodGallery.jpg'
export const mobileGallery =
  'https://d4gs6r4c7q68d.cloudfront.net/mobileGallery.jpg'
export const mobileLogo = 'https://d4gs6r4c7q68d.cloudfront.net/mobileLogo.png'
export const reserveButton =
  'https://d4gs6r4c7q68d.cloudfront.net/reserveButton.png'
export const viewMenu = 'https://d4gs6r4c7q68d.cloudfront.net/menuButton.png'

export { default as menu } from './masaMenu.pdf'
